(function () {
  const SELECTORS_ROOT = "[data-purnebu-selectors]";
  let lock = false;

  function selectRadio(input) {
    if (!input || input.checked || lock) return false;
    lock = true;
    input.checked = true;
    input.dispatchEvent(new Event("click", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
    lock = false;
    return true;
  }

  function analogScore(fromBox, toBox) {
    if (!fromBox || !toBox) return 0;
    let score = 0;
    if (fromBox.dataset.color && fromBox.dataset.color === toBox.dataset.color) score += 8;
    if (fromBox.dataset.size && fromBox.dataset.size === toBox.dataset.size) score += 6;
    if (fromBox.dataset.accent && fromBox.dataset.accent === toBox.dataset.accent) score += 5;
    if (fromBox.dataset.measure && fromBox.dataset.measure === toBox.dataset.measure) score += 5;
    return score;
  }

  function visibleMetalBoxes(wrap, karat) {
    return Array.from(wrap.querySelectorAll(".purnebu-metal__box")).filter((box) => {
      if (!karat) return true;
      return box.dataset.karat === karat;
    });
  }

  function applyKaratFilter(wrap, karat, preferredBox) {
    if (!wrap || !karat) return;
    wrap.setAttribute("data-purnebu-karat-filter", karat);
    wrap.querySelectorAll("[data-purnebu-karat]").forEach((btn) => {
      btn.setAttribute("aria-pressed", btn.getAttribute("data-purnebu-karat") === karat ? "true" : "false");
    });

    const visible = visibleMetalBoxes(wrap, karat);
    if (!visible.length) return;

    const checked = wrap.querySelector(".purnebu-metal__box input:checked");
    const checkedBox = checked ? checked.closest(".purnebu-metal__box") : null;
    if (checkedBox && visible.includes(checkedBox)) return;

    const source = preferredBox || checkedBox;
    let best = visible[0];
    let bestScore = -1;
    visible.forEach((box) => {
      const score = analogScore(source, box);
      if (score > bestScore) {
        best = box;
        bestScore = score;
      }
    });
    const radio = best.querySelector('input[type="radio"]');
    if (radio) selectRadio(radio);
  }

  function firstValidVariation(wrap) {
    const inputs = Array.from(wrap.querySelectorAll('input[type="radio"]'));
    return (
      inputs.find((input) => /^pendant$/i.test(String(input.value || "").trim())) ||
      inputs.find((input) => /^type\s*2$/i.test(String(input.value || "").trim()) && !input.classList.contains("unavailable")) ||
      inputs.find((input) => !input.classList.contains("unavailable") && !/^type\s*1$/i.test(String(input.value || "").trim())) ||
      inputs[0] ||
      null
    );
  }

  function syncVariation(root) {
    const variation = root.querySelector(".selector-wrapper--purnebu-variation");
    if (!variation) return;

    const pendantOn = Boolean(root.querySelector(".purnebu-length__box--pendant input:checked"));
    variation.hidden = pendantOn;
    variation.classList.toggle("is-purnebu-step-hidden", pendantOn);
    variation.setAttribute("aria-hidden", pendantOn ? "true" : "false");

    if (!pendantOn) return;

    const next = firstValidVariation(variation);
    if (next && !next.checked) selectRadio(next);
  }

  function productFrom(root) {
    const mapNode = root && root.querySelector("[data-purnebu-variant-map]");
    if (mapNode) {
      try {
        const rows = JSON.parse(mapNode.textContent);
        if (Array.isArray(rows) && rows.length) {
          return {
            variants: rows.map((row) => ({
              id: row.id,
              price: row.p,
              options: row.o,
            })),
          };
        }
      } catch (error) {
        /* fall through */
      }
    }

    const nodes = document.querySelectorAll("[data-product-json]");
    for (const node of nodes) {
      try {
        const data = JSON.parse(node.textContent);
        if (data && data.variants) return data;
      } catch (error) {
        /* try next */
      }
    }
    return null;
  }

  function variantOptions(variant) {
    if (variant.options && variant.options.length) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter((value) => value != null);
  }

  function variantPrice(variant) {
    const raw = variant.price;
    const number = Number(raw);
    if (!Number.isFinite(number)) return 0;
    if (String(raw).includes(".")) return Math.round(number * 100);
    return number;
  }

  function formatMoney(cents) {
    const format = (window.theme && (theme.moneyFormat || theme.moneyWithCurrencyFormat)) || "${{amount}}";
    const value = Math.abs(Number(cents) || 0);
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const match = String(format).match(placeholder);
    if (!match) return String(value / 100);

    function withDelimiters(number, precision, thousands, decimal) {
      const fixed = (number / 100).toFixed(precision);
      const parts = fixed.split(".");
      const left = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
      return parts[1] ? left + decimal + parts[1] : left;
    }

    let amount = "";
    switch (match[1]) {
      case "amount":
        amount = withDelimiters(value, 2, ",", ".");
        break;
      case "amount_no_decimals":
        amount = withDelimiters(value, 0, ",", ".");
        break;
      case "amount_with_comma_separator":
        amount = withDelimiters(value, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        amount = withDelimiters(value, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        amount = withDelimiters(value, 2, "'", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        amount = withDelimiters(value, 0, " ", ".");
        break;
      case "amount_with_space_separator":
        amount = withDelimiters(value, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        amount = withDelimiters(value, 2, " ", ".");
        break;
      default:
        amount = withDelimiters(value, 2, ",", ".");
    }
    return String(format).replace(placeholder, amount);
  }

  function optionIndex(input) {
    const raw = input.getAttribute("data-index") || "";
    const num = parseInt(raw.replace("option", ""), 10);
    return Number.isFinite(num) ? num - 1 : -1;
  }

  function currentSelections(root) {
    const map = [];
    root.querySelectorAll('input[data-single-option-selector]:checked').forEach((input) => {
      const index = optionIndex(input);
      if (index >= 0) map[index] = input.value;
    });
    return map;
  }

  function findVariant(product, selections) {
    if (!product || !product.variants) return null;
    return product.variants.find((variant) => {
      const options = variantOptions(variant);
      if (!options.length || options.length !== selections.length) return false;
      return options.every((value, index) => value === selections[index]);
    }) || null;
  }

  function writeDelta(el, diff) {
    if (!el) return;
    if (!diff) {
      el.hidden = true;
      el.textContent = "";
      el.removeAttribute("data-dir");
      return;
    }
    el.hidden = false;
    el.dataset.dir = diff > 0 ? "up" : "down";
    el.textContent = `${diff > 0 ? "+" : "−"}${formatMoney(Math.abs(diff))}`;
  }

  function updateDeltas(root) {
    const product = productFrom(root);
    if (!product) return;
    const current = currentSelections(root);
    const currentVariant = findVariant(product, current);
    if (!currentVariant) return;

    root.querySelectorAll("input[data-single-option-selector]").forEach((input) => {
      const delta = input.closest("label") && input.closest("label").querySelector("[data-purnebu-delta]");
      if (!delta) return;
      const index = optionIndex(input);
      if (index < 0) return;
      const trial = current.slice();
      trial[index] = input.value;
      const variant = findVariant(product, trial);
      if (!variant || variant.id === currentVariant.id) {
        writeDelta(delta, 0);
        return;
      }
      writeDelta(delta, variantPrice(variant) - variantPrice(currentVariant));
    });

    root.querySelectorAll("[data-purnebu-karat]").forEach((btn) => {
      const karat = btn.getAttribute("data-purnebu-karat");
      const delta = btn.querySelector("[data-purnebu-delta]");
      const wrap = btn.closest(".selector-wrapper--purnebu-metal");
      if (!delta || !wrap || !karat) return;
      const analog = visibleMetalBoxes(wrap, karat)[0];
      const radio = analog && analog.querySelector("input[data-single-option-selector]");
      if (!radio) {
        writeDelta(delta, 0);
        return;
      }
      const index = optionIndex(radio);
      const trial = current.slice();
      trial[index] = radio.value;
      const variant = findVariant(product, trial);
      if (!variant || variant.id === currentVariant.id) {
        writeDelta(delta, 0);
        return;
      }
      writeDelta(delta, variantPrice(variant) - variantPrice(currentVariant));
    });
  }

  function typeKey(value) {
    const raw = String(value || "").toLowerCase();
    const match = raw.match(/type\s*[-_]?\s*(\d+)/);
    return match ? `type${match[1]}` : raw.replace(/[^a-z0-9]+/g, "");
  }

  function slideAlt(slide) {
    const bits = [
      slide.getAttribute("data-media-alt"),
      slide.getAttribute("alt"),
      slide.querySelector("img") && slide.querySelector("img").getAttribute("alt"),
    ];
    return bits.filter(Boolean).join(" ").toLowerCase();
  }

  function isTypeGuideSlide(slide) {
    if (slide.hasAttribute("data-purnebu-type-guide")) return true;
    return /\btype\b/.test(slideAlt(slide));
  }

  function findTypeSlide(typeValue) {
    const gallery =
      document.querySelector("[data-product] product-images") || document.querySelector("product-images");
    if (!gallery) return null;
    const slides = Array.from(gallery.querySelectorAll("[data-media-id]"));
    if (!slides.length) return null;
    const key = typeKey(typeValue);
    const exact = slides.find((slide) => {
      const alt = slideAlt(slide);
      const altKey = alt.replace(/[^a-z0-9]+/g, "");
      return (key && altKey.includes(key)) || alt.includes(String(typeValue || "").toLowerCase());
    });
    if (exact && isTypeGuideSlide(exact)) return exact;
    return slides.find(isTypeGuideSlide) || exact || null;
  }

  function goToTypeImage(typeValue) {
    const panel = document.querySelector("[data-purnebu-chain-panel]");
    if (panel) {
      const header = document.querySelector("[data-header-height]");
      const offset = header ? header.getBoundingClientRect().height + 16 : 80;
      window.scrollTo({
        top: panel.getBoundingClientRect().top + window.scrollY - offset,
        behavior: "smooth",
      });
      return;
    }
    const slide = findTypeSlide(typeValue);
    if (!slide) return;
    const gallery = slide.closest("product-images");
    const id = slide.getAttribute("data-media-id");
    if (id && gallery) {
      gallery.dispatchEvent(
        new CustomEvent("theme:media:select", {
          bubbles: true,
          detail: { id },
        })
      );
    }
    const list = gallery && gallery.querySelector("[data-product-media-list]");
    if (list && window.matchMedia("(max-width: 749px)").matches) {
      list.scrollTo({ left: slide.offsetLeft, behavior: "smooth" });
      return;
    }
    const header = document.querySelector("[data-header-height]");
    const offset = header ? header.getBoundingClientRect().height + 16 : 80;
    window.scrollTo({
      top: slide.getBoundingClientRect().top + window.scrollY - offset,
      behavior: "smooth",
    });
  }

  function currentTypeValue(root) {
    const input = root.querySelector(".purnebu-variation__box input:checked");
    return input ? input.value : "Type";
  }

  function bind(root) {
    if (!root || root.dataset.purnebuBound === "1") return;
    root.dataset.purnebuBound = "1";

    root.addEventListener("click", (event) => {
      const info = event.target.closest("[data-purnebu-type-info]");
      if (info && root.contains(info)) {
        event.preventDefault();
        event.stopPropagation();
        goToTypeImage(currentTypeValue(root));
        return;
      }
      const karatBtn = event.target.closest("[data-purnebu-karat]");
      if (!karatBtn || !root.contains(karatBtn)) return;
      event.preventDefault();
      applyKaratFilter(karatBtn.closest(".selector-wrapper--purnebu-metal"), karatBtn.getAttribute("data-purnebu-karat"));
      updateDeltas(root);
    });

    root.addEventListener("change", (event) => {
      if (lock) return;
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;

      if (input.closest(".purnebu-length")) {
        syncVariation(root);
      }

      if (input.closest(".purnebu-variation")) {
        goToTypeImage(input.value);
      }

      if (input.closest(".purnebu-metal")) {
        const wrap = input.closest(".selector-wrapper--purnebu-metal");
        const karat = input.closest(".purnebu-metal__box")?.dataset.karat;
        if (wrap && karat && wrap.querySelector("[data-purnebu-karat]")) {
          wrap.setAttribute("data-purnebu-karat-filter", karat);
          wrap.querySelectorAll("[data-purnebu-karat]").forEach((btn) => {
            btn.setAttribute("aria-pressed", btn.getAttribute("data-purnebu-karat") === karat ? "true" : "false");
          });
        }
      }
      updateDeltas(root);
    });

    refresh(root);
  }

  function refresh(root) {
    const metalWrap = root.querySelector(".selector-wrapper--purnebu-metal[data-purnebu-karat-filter]");
    if (metalWrap) {
      const currentKarat =
        metalWrap.querySelector(".purnebu-metal__box input:checked")?.closest(".purnebu-metal__box")?.dataset.karat ||
        metalWrap.getAttribute("data-purnebu-karat-filter");
      if (currentKarat) applyKaratFilter(metalWrap, currentKarat);
    }
    syncVariation(root);
    updateDeltas(root);
  }

  function variantGroups(section) {
    const node = section && section.querySelector("[data-pb-variant-groups]");
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function showGroup(event) {
    const variant = event.detail && event.detail.variant;
    if (!variant) return;
    const section = event.target.closest && event.target.closest('[data-section-type="product"]');
    const gallery = section && section.querySelector("product-images[data-pb-grouped]");
    const groups = gallery && variantGroups(section);
    const group = groups && groups[String(variant.id)];
    if (!group || gallery.getAttribute("data-pb-active-group") === group) return;

    gallery.setAttribute("data-pb-active-group", group);
    gallery.querySelectorAll("[data-pb-group]").forEach((item) => {
      item.toggleAttribute("data-pb-group-on", item.getAttribute("data-pb-group") === group);
    });

    const list = gallery.querySelector("[data-product-media-list]");
    if (list) list.scrollTo({ left: 0 });
    const mediaId = variant.featured_media && variant.featured_media.id;
    const slide = mediaId && gallery.querySelector(`[data-image-id="${mediaId}"]`);
    if (slide) {
      slide.dispatchEvent(
        new CustomEvent("theme:media:select", {
          bubbles: true,
          detail: { id: slide.getAttribute("data-media-id") },
        })
      );
    }
  }

  document.addEventListener("theme:variant:change", showGroup);

  function init() {
    document.querySelectorAll(SELECTORS_ROOT).forEach((root) => {
      if (root.dataset.purnebuBound === "1") {
        refresh(root);
        return;
      }
      bind(root);
    });
  }

  function boot() {
    init();
    window.setTimeout(init, 80);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", init);
})();
